module.exports = __webpack_public_path__ + "img/Course-emotions.d0114834.jpg";